<template>
  <div>
    <div class="banner">
      <img src="https://firebasestorage.googleapis.com/v0/b/foxfox-honda.appspot.com/o/LOGO_VGxLIA-01.png?alt=media&token=ad128f7b-1718-4830-8534-c06999f9e338" style="height:90px !important;">
    </div>
    <div class="card" v-show="!confirmSuccess">

      <div class="card-content">
        <div class="media">
          <div class="media-left">
            <figure class="image is-48x48">
              <img :src="profile.pictureUrl" alt="Customer Picture">
            </figure>
          </div>
          <div class="media-content">
            <p class="title is-4">{{ carInfo.customerName }}</p>

          </div>
        </div>

        <div class="content">
          <b>ยินดีต้อนรับสู่ V.Group Honda Service สาขา {{ branchSelected }}</b><br>
          วันนี้คุณได้นำรถทะเบียน {{ carInfo.licenseNo }}<br>
          เลขที่ตัวถัง {{ carInfo.frameNo }}<br>
          เข้าศูนย์บริการ<br>
          <br>
          <!--time datetime="2016-1-1">11:09 PM - 1 Jan 2016</time-->
        </div>
      </div>
    </div><br>
    <label class="checkbox" v-show="!confirmSuccess">
      <input type="checkbox" name="agree" id="agree">
      ยอมรับ <a href="https://foxfox-honda.web.app/pdpa" target="_blank" style="text-decoration:underline">นโยบายข้อมูลส่วนบุคคล</a>
    </label><br><br>

    <button class="button is-success" v-on:click="confirmCarInfo" v-show="!confirmSuccess">{{ btn_action }}</button>

    <article class="message is-success" v-show="confirmSuccess">
      <div class="message-header">
        <p>ยืนยันข้อมูลเรียบร้อย</p>
        <button class="delete" aria-label="delete"></button>
      </div>
      <div class="message-body">
        คุณสามารถติดตามความคืบหน้าการให้บริการได้ที่ <a href="line://ti/p/@vgrouplinked">line://ti/p/@vgrouplinked</a>
      </div>
    </article>
  </div>
</template>
<script>
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'ConfirmBP',
  beforeCreate () {
  },
  components: {
    QrcodeVue
  },
  data: () => ({
    size: 200,
    confirmSuccess: false,
    profile: {
      userId: '',
      displayName: '',
      pictureUrl: '',
      statusMessage: ''
    },
    branch: [],
    branchSelected: '',
    branchCode: '',
    carInfo: {
      branchId: '',
      customerName: '',
      frameNo: '',
      licenseNo: ''
    },
    carId: '',
    btn_action: 'ยืนยันข้อมูลถูกต้อง'
  }),
  async mounted () {
    await this.$liff.init({ liffId: this.$liffId_Service_ConfirmBP }, function (data) {})
    let _this = this
    _this.branch = this.$branchList
    await _this.checkLiffLogin()
    const queryString = decodeURIComponent(decodeURIComponent(window.location.search).replace('?liff.state=', ''))
    const params = new URLSearchParams(queryString)
    const branchCode = params.get('branchCode')
    _this.carId = params.get('carId')
    _this.branchCode = branchCode
    _this.branch.map((item) => {
      _this.branchSelected = (item.id === _this.branchCode) ? item.name : _this.branchSelected
      return true
    })
    _this.getCarInfo()
  },
  methods: {
    async checkLiffLogin () {
      await this.$liff.ready.then(async () => {
        if (process.env.NODE_ENV === 'development') {
          this.getProfile_dev()
        } else {
          if (!this.$liff.isLoggedIn()) {
            this.$liff.login({redirectUri: window.location})
          } else {
            await this.getProfile()
          }
        }
      })
    },
    getCarInfo () {
      let _this = this
      this.$axios
        .get(`${this.$apiUrl}getBPInfo?carId=${_this.carId}`)
        .then(response => {
          _this.carInfo = response.data
        })
    },
    confirmCarInfo () {
      var agree = document.getElementById('agree')
      if (!agree.checked) {
        alert('กรุณาคลิกยอมรับนโยบายข้อมูลส่วนบุคคล')
      } else {
        let _this = this
        _this.btn_action = 'กำลังยืนยันข้อมูล กรุณารอสักครู่'
        _this.carInfo.branchId = _this.branchCode
        let params = {
          userId: _this.profile.userId,
          carId: _this.carId
        }
        this.$axios
          .post(`${this.$apiUrl}setCustomerConfirmBP`, params)
          .then(response => {
            _this.confirmSuccess = true
            _this.btn_action = 'ยืนยันข้อมูล'
          })
      }
    },
    openWindow () {
      this.$liff.openWindow({
        url: 'https://developers.line.me/en/docs/liff/overview/'
      })
    },
    closeWindow () {
      this.$liff.closeWindow()
    },
    sendMessage () {
      let _this = this
      this.$liff.sendMessages([
        {
          type: 'text',
          text: 'You/\'ve successfully sent a message! Hooray!'
        },
        {
          type: 'sticker',
          packageId: '2',
          stickerId: '144'
        }
      ]).then(function () {
        _this.closeWindow()
        console.log('Message sent')
      }).catch(function (error) {
        console.log('Error sending message: ' + error)
      })
    },
    async getProfile () {
      let _this = this
      await this.$liff.getProfile().then(function (profile) {
        _this.profile = profile
      }).catch(function (error) {
        console.log('Error getting profile: ' + error)
      })
    },
    getProfile_dev () {
      this.profile = {
        'displayName': 'Pamorn Trivorrarat',
        'pictureUrl': 'https://profile.line-scdn.net/0hehdTWCiWOkdZLRKhl6VFEGVoNCouAzwPIUl2JX4pNnQnSHsUMRx8dCgoNCUmTS1BMRhzKHQpMyN9',
        'statusMessage': 'ใช้ไลน์อันนี้นะคร้าบ',
        'userId': 'U691b2080970333bbeb4930dadc6618b6'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ConfirmBP.vue